import { EndPoints, post } from '../';
export function sendPush(request) {
    return post(EndPoints.push, request);
}
